<img [src]="img" [alt]="alt" (load)="imgLoaded()" (error)="imgError()" />
